import { render } from "./FeeDetailsView.vue?vue&type=template&id=20848e10"
import script from "./FeeDetailsView.vue?vue&type=script&lang=js"
export * from "./FeeDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__